import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { Club } from "@/models";

const state = {
  clubs: [],
  clubsLoading: false,
  meta: {},
  club: new Club(),
  clubLoading: false,
  video: {},
  videos: [],
  limitedVideos: [],
  videosLoading: false,
  clubNameExists: false,
  clubNameLoading: false,
  createClub: "",
  createClubLoading: false,
  clubImages: "",
  clubImagesLoading: false,
  deleteImages: [],
  deleteImagesloading: false,
  allClubs: [],
  allClubsLoading: false,
  count: {},
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
